/*eslint-disable no-unused-vars*/

import { createApp } from 'vue'
import Maska from 'maska'
import form from '@/store/form'
import tippy from 'tippy.js'
import './assets/js/css/ImportCss'
import Cookies from 'js-cookie'
import AppStates from '@/components/States/AppStates.vue'
import AppForm from '@/components/Form/AppForm.vue'
import { Fancybox } from '@fancyapps/ui'
import SwiperSlider from '@/assets/js/Swiper/Swiper'
import HeaderMobile from '@/assets/js/Header/Mobile/HeaderMobile'
import SectionButtons from '@/assets/js/Section/Buttons/SectionButtons'
import ToggleProduct from '@/assets/js/Toggle/Product/ToggleProduct'
import Video from '@/assets/js/Video/Video'
import Gallery from '@/assets/js/Gallery/Gallery'
import Prop from '@/assets/js/Prop/Prop'
import Review from '@/assets/js/Review/Review'
import AjaxFavorite from '@/assets/js/Ajax/Favorite/AjaxFavorite'
import AjaxCommercial from '@/assets/js/Ajax/Commercial/AjaxCommercial'

// Подключаем глобально jQuery
const $ = window.$ = window.jQuery = require('jquery')

// Подключаем глобально Cookie
window.Cookies = Cookies

document.addEventListener('DOMContentLoaded', () => {
    Fancybox.bind('[data-fancybox]', {
        mainClass: 'fancybox--popup'
    })

    tippy('.tippy--review', {
        theme: 'light',
        arrow: true,
        placement: 'bottom-start',
        animation: 'scale-extreme',
        content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            return template.innerHTML;
        },
        allowHTML: true
    })

    new SwiperSlider()
    new HeaderMobile()
    new SectionButtons()
    new ToggleProduct()
    new Video()
    new Gallery()
    new Prop()
    new Review()
    new AjaxFavorite()
    new AjaxCommercial()

    if(document.getElementById('block--states') != null) {
        createApp({})
            .component('block-states', AppStates)
            .mount('#block--states')
    }

    if(document.getElementById('block--form') != null) {
        createApp({})
            .component('block-form', AppForm)
            .use(Maska)
            .use(form)
            .mount('#block--form')
    }
})
